// One free-package or grant card (amount, official name, who it is for, sourced terms, period, form link).
// Used on /free-software (the free package) and /grants (the three IMDA grants).
import { Cite } from './Cite'
import type { Grant } from '../content/facts'
import { useT } from './i18n'
import { MONO, card, ext, label } from './ui'

export function GrantCard({ g }: { g: Grant }) {
  const { tc } = useT()
  return (
    <div id={g.id === 'foc' ? 'foc' : undefined} style={{ ...card, scrollMarginTop: 96 }}>
      <span style={{ fontSize: 'clamp(36px,3.4vw,48px)', fontWeight: 500, letterSpacing: '-0.03em', lineHeight: 1, color: '#b2f5dc' }}>{tc(g, 'amount')}</span>
      {/* Grant names are official programme titles: shown in English */}
      <h3 lang="en" style={{ margin: 0, fontSize: 18, fontWeight: 500, lineHeight: 1.25 }}>{g.name}</h3>
      <span style={{ ...label, color: '#9dbdb2', lineHeight: 1.5 }}>{tc(g, 'who').toLocaleUpperCase()}</span>
      <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14.5, lineHeight: 1.5, color: '#d9e8e2' }}>
        {g.terms.map((c, i) => <li key={i}>{tc(c)}{g.terms[i + 1]?.sourceLabel !== c.sourceLabel && <> <Cite c={c} /></>}</li>)}
      </ul>
      <span style={{ fontSize: 13, color: '#9dbdb2', marginTop: 'auto', paddingTop: 8 }}>{tc(g, 'period')}</span>
      {g.href && <a href={g.href.url} {...ext} style={{ fontFamily: MONO, fontSize: 12, letterSpacing: '0.06em' }}>{tc(g.href, 'label')} →</a>}
    </div>
  )
}
